import src from "IMAGE";
export default { src, width: 5652, height: 15, blurWidth: 8, blurHeight: 1, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAABCAYAAADjAO9DAAAALElEQVR42gEhAN7/AGhTUch2XVTMdGJdyHRcXcNsU0/CaFZXxGhYW8h0WFDL9o4PJiEAMd4AAAAASUVORK5CYII="};
